export default {
  nav: {
    title: 'Tags',
  }
}
